module.exports = __webpack_public_path__ + "static/media/et.cce3dc9f.svg";